import { Component } from 'react';
import styled from '@emotion/styled';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { dataTrackMap, ASSET_URLS } from '../../utils';
import { WARRANTIES, POPOVERS } from '../data.js';

const {InfoCircle, TriangleIcon} = ASSET_URLS;

import {
    StandardLogoText,
    SystemProtectionLogo,
    PreferredProtectionLogo,
    PlatinumProtectionLogo,
    FlexRow,
    FlexCol,
} from '../desktop/components.js';

const AccordianContainer = styled.div`
  & + .footnote {
    margin-top: 25px;
  }
`;

const Accordian = styled.div`
  & {
  position: relative;
  border: 1px solid #f8f8f8;
  
  label {
    padding: 10px 15px;
    color: black;
    font-size: 16px;
    background: #fff;
    border-bottom: 1px solid #bcbcbc;
    position: relative;
    width: 100%;
    margin: 0;
    cursor: pointer;
    font-weight: 500;
    min-height: 89px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:after {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      font-weight: 700;
    }
  }

  .expand-collapse {
    transition: max-height .5s cubic-bezier(0, 1, 0, 1);
    max-height: 0;
    background: white;
    overflow: hidden;
  }

  .content {
    font-size: 14px;
  }

  input[type=checkbox] {
    display: none;

    &:checked ~ .expand-collapse {
      max-height: 800px;
      transition: max-height 1s ease-in-out;
    }
  }

  .arrow-container {
      display: flex;
      justify-content: flex-end;
      padding-right: 15px;
      align-items: center;
  }

  input[type=checkbox]:checked + label .arrow-container {
      .up-arrow {
          display:block;
      }
      .down-arrow {
          display: none;
      }
  }

  input[type=checkbox]:not(:checked) + label .arrow-container {
      .up-arrow { display: none; }
      .down-arrow{ display: block; }
  }


}
`;

const CategoryHeader = styled(FlexRow)`
flex: 1 100%;
height: 33px;

font-family: OCRoboto;
font-size: 13px;
font-weight: bold;
font-style: normal;
font-stretch: normal;
line-height: normal;
letter-spacing: 0.5px;
color: #000000;

justify-content: left;
align-items: center;
background-color: #efefef;
padding: 10px;
border-bottom: 1px solid #cbcbcb;
border-top: 1px solid #cbcbcb;
`;

const WarrantyDetailName = styled.div`
font-family: OCRoboto;
font-size: 13px;
font-weight: bold;
font-style: normal;
font-stretch: normal;
line-height: normal;
letter-spacing: normal;
color: #000000;
display: inline;
`;

const WarrantyDetailValue = styled.div`
opacity: 0.6;
  font-family: OCRoboto;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const BackText = styled.span`
font-family: OCRoboto;
  font-size: 11px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  text-align: center;
  color: #000000;
  padding-right: 10px;
  `;

export default class MobileWarranty extends Component {
    constructor(props) {
        super(props);
    }

    infoPopover(id, titleText, bodyText) {
        const {InfoCircle} = ASSET_URLS;
        return (
            <OverlayTrigger
                trigger="click"
                placement={'right'}
                rootClose
                overlay={
                    <Popover id={id} style={{ opacity: 1 }} placement={'right'}>
                        <Popover.Title>{titleText}</Popover.Title>
                        <Popover.Content>{bodyText}</Popover.Content>
                    </Popover>
                }
            >
                <img
                    src={InfoCircle}
                    style={{
                        display: 'inline',
                        marginLeft: '7px',
                    }}
                    {...dataTrackMap({
                        track: 'tooltip',
                        destination: `${titleText} Tooltip`
                    })}
                />
            </OverlayTrigger>
        )
    }

    renderLogo(v) {
        const { SYSTEM_PROTECTION_LOGO, PREFERRED_PROTECTION_LOGO, PLATINUM_PROTECTION_LOGO} = ASSET_URLS;
        switch (v) {
            case 'standard':
                return (<StandardLogoText style={{marginTop: '15px'}}>Standard Product<br/>Limited
                    Warranty</StandardLogoText>)
            case 'system-protection':
                return (<SystemProtectionLogo src={SYSTEM_PROTECTION_LOGO}/>)
            case 'preferred-protection':
                return (<PreferredProtectionLogo src={PREFERRED_PROTECTION_LOGO}/>)
            case 'platinum-protection':
                return (<PlatinumProtectionLogo src={PLATINUM_PROTECTION_LOGO}/>)
        }
    }

    renderWarrantyData(warranty) {
        return (
            <FlexCol>
                <CategoryHeader>PRODUCT DEFECTS COVERAGE</CategoryHeader>
                {
                    warranty['Product Defects Coverage'].map((elem, index) => {
                        let key = Object.keys(elem)[0];
                        let value = elem[key];
                        let popoverData = POPOVERS.find(function(o){
                            return ( o.name === key)
                        });
                        let popoverTitle;
                        let popoverBody;
                        if (popoverData) {
                            popoverTitle = popoverData['titleText'];
                            popoverBody = popoverData['bodyText'];
                        }
                        return (
                            <div key={index} style={{
                                display: 'block',
                                paddingLeft: '10px',
                                paddingTop: '3px',
                                paddingBottom: '3px',
                                borderBottom: '1px solid #cbcbcb'
                            }}>
                                <div style={{display: 'block'}}>
                                    <WarrantyDetailName
                                        dangerouslySetInnerHTML={{
                                            __html: key,
                                        }}/>
                                    { popoverTitle ? this.infoPopover(index, popoverTitle, popoverBody) : ''}
                                </div>
                                <WarrantyDetailValue
                                    dangerouslySetInnerHTML={{
                                        __html: value,
                                    }}/>
                            </div>
                        )
                    })
                }
                <CategoryHeader>WORKMANSHIP COVERAGE</CategoryHeader>
                {
                    warranty['Workmanship Coverage'].map((elem, index) => {
                        let key = Object.keys(elem)[0];
                        let value = elem[key];
                        let popoverData = POPOVERS.find(function(o){
                            return ( o.name === key)
                        });
                        let popoverTitle;
                        let popoverBody;
                        if (popoverData) {
                            popoverTitle = popoverData['titleText'];
                            popoverBody = popoverData['bodyText'];
                        }
                        return (
                            <div key={index} style={{
                                display: 'block',
                                paddingLeft: '10px',
                                paddingTop: '3px',
                                paddingBottom: '3px',
                                borderBottom: '1px solid #cbcbcb'
                            }}>
                                <div style={{display: 'block'}}>
                                    <WarrantyDetailName
                                        dangerouslySetInnerHTML={{
                                            __html: key,
                                        }}/>
                                    { popoverTitle ? this.infoPopover(index, popoverTitle, popoverBody) : ''}
                                </div>
                                <WarrantyDetailValue
                                    dangerouslySetInnerHTML={{
                                        __html: value,
                                    }}/>
                            </div>
                        )
                    })
                }
                <CategoryHeader>KEY REQUIREMENTS</CategoryHeader>
                {
                    warranty['Key Requirements'].map((elem, index) => {
                        let key = Object.keys(elem)[0];
                        let value = elem[key];
                        let popoverData = POPOVERS.find(function(o){
                            return ( o.name === key)
                        });
                        let popoverTitle;
                        let popoverBody;
                        if (popoverData) {
                            popoverTitle = popoverData['titleText'];
                            popoverBody = popoverData['bodyText'];
                        }
                        return (
                            <div key={index} style={{
                                display: 'block',
                                paddingLeft: '10px',
                                paddingTop: '3px',
                                paddingBottom: '3px',
                                borderBottom: '1px solid #cbcbcb'
                            }}>
                                <div style={{display: 'block'}}>
                                    <WarrantyDetailName
                                        dangerouslySetInnerHTML={{
                                            __html: key,
                                        }}/>
                                    { popoverTitle ? this.infoPopover(index, popoverTitle, popoverBody) : ''}
                                </div>
                                <WarrantyDetailValue
                                    dangerouslySetInnerHTML={{
                                        __html: value,
                                    }}/>
                            </div>
                        )
                    })
                }
            </FlexCol>
        )
    }

    renderAccordian(warrantyArray, title, color) {
        let {standardCoverage, extendedCoverage} = this.props.activeWarranties;
        let n = standardCoverage.length + extendedCoverage.length;
        let titleDiv = title;
        let render = warrantyArray.map((warranty, index) => {
            return (
                <div key={`${warranty}-${index}`}>
                    <input type="checkbox" id={`item${warranty}${index}`} defaultChecked={(n === 1) ? true : false}
                           disabled={(n === 1) ? true : false} ref={this.refs[index]}/>
                    <label for={`item${warranty}${index}`} data-track="reveal"
                           data-track-accordion={`item${warranty}${index}_track`}>
                        {this.renderLogo(warranty)}
                        <div className="arrow-container" style={{display: (n === 1) ? 'None' : 'flex'}}>
                            <BackText className="up-arrow">Back</BackText>
                            <img src={TriangleIcon} className="down-arrow"/>
                            <img src={TriangleIcon} style={{transform: 'rotate(180deg)'}} className="up-arrow"/>
                        </div>
                    </label>
                    <div className="expand-collapse">
                        <div className="content">
                            <div className="document-download-list">
                                {this.renderWarrantyData(WARRANTIES.find(o => o.slug === warranty))}
                            </div>
                        </div>
                    </div>
                </div>
            )
        });
        render = <div>
            <div style={{
                backgroundColor: color,
                fontFamily: "OCRoboto",
                textAlign: "center",
                fontWeight: "900",
                height: "45px",
                margin: "auto",
                padding: "15px",
                color: "black"
            }}>{titleDiv}</div>
            {render}
        </div>
        return render;

    }

    render() {
        const {standardCoverage, extendedCoverage} = this.props.activeWarranties;
        return (
            <AccordianContainer>
                <Accordian>
                    {
                        (standardCoverage.length === 0)
                            ? null
                            : (
                                this.renderAccordian(standardCoverage, "STANDARD COVERAGE", '#e8e8e8')
                            )
                    }
                    {
                        (extendedCoverage.length === 0)
                            ? null
                            : (
                                this.renderAccordian(extendedCoverage, "EXTENDED COVERAGE", "#fde4f0")
                            )
                    }
                </Accordian>
            </AccordianContainer>
        )
    }
}
